var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "assistant-chat-container",
      class: {
        "assistant-new": _vm.mode == "assistant",
        "fixed download": _vm.download,
        finish: _vm.level == _vm.publishBotMessages.length
      },
      style: { height: _vm.screenHeight }
    },
    [
      _c(
        "section",
        {
          staticClass: "msger",
          style: { height: _vm.screenHeight },
          attrs: { id: "msger" }
        },
        [
          _c("header", { staticClass: "msger-header" }, [
            _c("div", { staticClass: "msger-header-title" }, [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "40",
                    height: "40",
                    viewBox: "0 0 24 24",
                    fill: "none"
                  }
                },
                [
                  _c("rect", {
                    staticStyle: {
                      "mix-blend-mode": "color-burn",
                      fill: "#029973"
                    },
                    attrs: {
                      width: "24",
                      height: "24",
                      rx: "12",
                      fill: "url(#paint0_linear_12533_12795)"
                    }
                  }),
                  _c("path", {
                    staticStyle: { fill: "#fff" },
                    attrs: {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d:
                        "M4.48594 18.8968C5.77797 16.9964 8.4222 15.2973 11.9966 15.2973C15.5773 15.2973 18.2235 16.996 19.5164 18.896C17.6519 20.9268 14.975 22.1998 12.0008 22.1998C9.02695 22.1998 6.35037 20.9272 4.48594 18.8968ZM8.01368 9.11467C8.01368 11.5917 9.86039 13.5094 12.0066 13.5094C14.1427 13.5094 15.9994 11.5917 15.9994 9.09469C15.9994 6.62763 14.1427 4.7998 12.0066 4.7998C9.87037 4.7998 8.01368 6.66758 8.01368 9.11467Z",
                      fill: "white"
                    }
                  }),
                  _c(
                    "defs",
                    [
                      _c(
                        "linearGradient",
                        {
                          attrs: {
                            id: "paint0_linear_12533_12795",
                            x1: "12",
                            y1: "0",
                            x2: "12",
                            y2: "24",
                            gradientUnits: "userSpaceOnUse"
                          }
                        },
                        [
                          _c("stop", { attrs: { "stop-color": "#A5AAB6" } }),
                          _c("stop", {
                            attrs: { offset: "1", "stop-color": "#868A93" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "msger-header-info",
                  attrs: { id: "msger-header-info" }
                },
                [
                  _c("h5", [_vm._v(_vm._s(_vm.botName))]),
                  _c("span", [_vm._v("​" + _vm._s(_vm.botPhone))])
                ]
              )
            ]),
            _c("div", { staticClass: "msger-timer" }, [
              _vm.countdown > 0
                ? _c(
                    "div",
                    { staticClass: "d-flex align-items-center gap-10" },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "16",
                            height: "17",
                            viewBox: "0 0 16 17",
                            fill: "none"
                          }
                        },
                        [
                          _c(
                            "g",
                            {
                              attrs: { "clip-path": "url(#clip0_12601_8403)" }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d:
                                    "M15.3346 8.03368C15.1871 6.2058 14.3631 4.49868 13.0237 3.24608C11.6844 1.99347 9.92595 1.28546 8.0923 1.26045C6.25865 1.23545 4.4816 1.89525 3.10858 3.11087C1.73557 4.32649 0.865313 6.01051 0.667969 7.83368H2.0013C2.12142 6.70234 2.55896 5.62802 3.26345 4.73468C3.96794 3.84135 4.91066 3.16541 5.98282 2.78486C7.05499 2.40431 8.2129 2.33466 9.32295 2.58396C10.433 2.83325 11.4499 3.39132 12.2564 4.19378C13.0629 4.99623 13.6261 6.01036 13.8809 7.11914C14.1358 8.22793 14.0719 9.38618 13.6968 10.4602C13.3216 11.5343 12.6504 12.4804 11.7606 13.1893C10.8708 13.8983 9.79869 14.3412 8.66797 14.467V15.8003C10.5691 15.6222 12.3268 14.7128 13.5705 13.2639C14.8141 11.815 15.4466 9.93985 15.3346 8.03368Z",
                                  fill: "black",
                                  "fill-opacity": "0.5"
                                }
                              }),
                              _c("path", {
                                attrs: {
                                  d:
                                    "M8.00078 4.50083C7.91047 4.49631 7.82018 4.51021 7.73541 4.54168C7.65064 4.57316 7.57316 4.62155 7.50768 4.68391C7.4422 4.74627 7.39009 4.8213 7.35452 4.90444C7.31895 4.98757 7.30067 5.07708 7.30078 5.1675V8.8675L10.9674 11.0675C11.0793 11.1311 11.2054 11.1655 11.3341 11.1675C11.45 11.1691 11.5642 11.1389 11.6641 11.0801C11.764 11.0213 11.8459 10.9363 11.9008 10.8342C11.9479 10.7607 11.9794 10.6782 11.9932 10.592C12.0069 10.5058 12.0027 10.4177 11.9808 10.3332C11.9589 10.2487 11.9198 10.1696 11.8658 10.1009C11.8119 10.0323 11.7444 9.97548 11.6674 9.93417L8.66745 8.13417V5.1675C8.66745 4.99069 8.59721 4.82112 8.47219 4.6961C8.34716 4.57107 8.17759 4.50083 8.00078 4.50083Z",
                                  fill: "black",
                                  "fill-opacity": "0.5"
                                }
                              }),
                              _c("path", {
                                attrs: {
                                  d:
                                    "M6.63411 11.1667H6.30078V10.5C6.30078 10.2374 6.24905 9.97728 6.14854 9.73463C6.04803 9.49198 5.90071 9.2715 5.71499 9.08579C5.52928 8.90007 5.3088 8.75275 5.06615 8.65224C4.8235 8.55173 4.56342 8.5 4.30078 8.5C4.03814 8.5 3.77807 8.55173 3.53541 8.65224C3.29276 8.75275 3.07228 8.90007 2.88657 9.08579C2.70085 9.2715 2.55353 9.49198 2.45302 9.73463C2.35251 9.97728 2.30078 10.2374 2.30078 10.5V11.1667H1.96745C1.79064 11.1667 1.62107 11.2369 1.49604 11.3619C1.37102 11.487 1.30078 11.6565 1.30078 11.8333V15.1667C1.30078 15.3435 1.37102 15.513 1.49604 15.6381C1.62107 15.7631 1.79064 15.8333 1.96745 15.8333H6.63411C6.72293 15.8381 6.81176 15.8242 6.89482 15.7924C6.97788 15.7606 7.05332 15.7117 7.11621 15.6488C7.1791 15.5859 7.22804 15.5104 7.25984 15.4274C7.29164 15.3443 7.30559 15.2555 7.30078 15.1667V11.8333C7.30559 11.7445 7.29164 11.6557 7.25984 11.5726C7.22804 11.4896 7.1791 11.4141 7.11621 11.3512C7.05332 11.2883 6.97788 11.2394 6.89482 11.2076C6.81176 11.1758 6.72293 11.1619 6.63411 11.1667ZM3.63411 10.5C3.63411 10.3232 3.70435 10.1536 3.82938 10.0286C3.9544 9.90357 4.12397 9.83333 4.30078 9.83333C4.47759 9.83333 4.64716 9.90357 4.77219 10.0286C4.89721 10.1536 4.96745 10.3232 4.96745 10.5V11.1667H3.63411V10.5Z",
                                  fill: "black",
                                  "fill-opacity": "0.5"
                                }
                              })
                            ]
                          ),
                          _c("defs", [
                            _c(
                              "clipPath",
                              { attrs: { id: "clip0_12601_8403" } },
                              [
                                _c("rect", {
                                  attrs: {
                                    width: "16",
                                    height: "16",
                                    fill: "white",
                                    transform: "translate(0 0.5)"
                                  }
                                })
                              ]
                            )
                          ])
                        ]
                      ),
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm._f("trans")("st_public.Live_chat_will_ends")
                          )
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "msger-countdown",
                            attrs: { id: "msger-countdown" }
                          },
                          [_vm._v(_vm._s(_vm.formatTime(_vm.countdown)))]
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _c("span", [_vm._v(_vm._s(_vm.currentDate()))])
            ]),
            _vm.country_code != "us"
              ? _c("ul", { staticClass: "navigation" }, [
                  _c(
                    "li",
                    [
                      _c(
                        "nuxt-link",
                        {
                          staticClass: "item",
                          attrs: {
                            to: {
                              name: "lang-assistant-id-token",
                              params: {
                                lang: _vm.lang == "ar" ? "en" : "ar",
                                id: this.$root._route.params.id,
                                token: this.$root._route.params.token
                              }
                            }
                          }
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "12",
                                height: "12",
                                viewBox: "0 0 12 12",
                                fill: "none"
                              }
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    "clip-path": "url(#clip0_12742_28092)"
                                  }
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d:
                                        "M11 6C11 6.6566 10.8706 7.3068 10.6194 7.9134C10.3681 8.52005 9.99985 9.07125 9.53555 9.53555C9.07125 9.99985 8.52005 10.3681 7.9134 10.6194C7.3068 10.8706 6.6566 11 6 11C5.3434 11 4.69321 10.8706 4.08658 10.6194C3.47995 10.3681 2.92876 9.99985 2.46446 9.53555C2.00017 9.07125 1.63187 8.52005 1.3806 7.9134C1.12933 7.3068 1 6.6566 1 6C1 5.3434 1.12933 4.69321 1.3806 4.08658C1.63187 3.47995 2.00017 2.92876 2.46446 2.46446C2.92876 2.00017 3.47995 1.63187 4.08658 1.3806C4.69321 1.12933 5.3434 1 6 1C6.6566 1 7.3068 1.12933 7.9134 1.3806C8.52005 1.63187 9.07125 2.00017 9.53555 2.46446C9.99985 2.92876 10.3681 3.47995 10.6194 4.08658C10.8706 4.69321 11 5.3434 11 6Z",
                                      stroke: "white"
                                    }
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d:
                                        "M8 6C8 6.6566 7.94825 7.3068 7.84775 7.9134C7.74725 8.52005 7.59995 9.07125 7.4142 9.53555C7.2285 9.99985 7.008 10.3681 6.76535 10.6194C6.5227 10.8706 6.26265 11 6 11C5.73735 11 5.4773 10.8706 5.23465 10.6194C4.99198 10.3681 4.7715 9.99985 4.58578 9.53555C4.40007 9.07125 4.25275 8.52005 4.15224 7.9134C4.05173 7.3068 4 6.6566 4 6C4 5.3434 4.05173 4.69321 4.15224 4.08658C4.25275 3.47995 4.40007 2.92876 4.58578 2.46446C4.7715 2.00017 4.99198 1.63187 5.23465 1.3806C5.4773 1.12933 5.73735 1 6 1C6.26265 1 6.5227 1.12933 6.76535 1.3806C7.008 1.63187 7.2285 2.00017 7.4142 2.46446C7.59995 2.92876 7.74725 3.47995 7.84775 4.08658C7.94825 4.69321 8 5.3434 8 6Z",
                                      stroke: "white"
                                    }
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M1 6H11",
                                      stroke: "white",
                                      "stroke-linecap": "round"
                                    }
                                  })
                                ]
                              ),
                              _c("defs", [
                                _c(
                                  "clipPath",
                                  { attrs: { id: "clip0_12742_28092" } },
                                  [
                                    _c("rect", {
                                      attrs: {
                                        width: "12",
                                        height: "12",
                                        fill: "white"
                                      }
                                    })
                                  ]
                                )
                              ])
                            ]
                          ),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.lang == "ar" ? "English" : "العربية") +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e()
          ]),
          _c(
            "main",
            { staticClass: "msger-chat", attrs: { id: "msger-chat" } },
            _vm._l(_vm.messages, function(item, index) {
              return _c(
                "div",
                { key: index, class: "msg " + item.side + "-msg" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex",
                      class: { "w-full": item.text.mode == "assistant" }
                    },
                    [
                      item.side == "left"
                        ? _c("div", { staticClass: "msg-img" }, [
                            _c("img", {
                              staticClass: "feature-purple__logo",
                              attrs: {
                                width: "32",
                                height: "32",
                                src: require("assets/assistant.svg")
                              }
                            })
                          ])
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "msg-bubble w-full" },
                        [
                          _c("div", { staticClass: "msg-info" }, [
                            _c("div", { staticClass: "msg-info-name" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.formatedName(item)))
                              ]),
                              item.side == "left"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("trans")("st_public.Assistant")
                                      )
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ]),
                          !item.isLoading
                            ? [
                                item.side == "right"
                                  ? [
                                      _c("div", {
                                        staticClass: "msg-text",
                                        class: {
                                          disabled:
                                            _vm.level ==
                                            _vm.publishBotMessages.length
                                        },
                                        domProps: {
                                          innerHTML: _vm._s(item.text)
                                        }
                                      })
                                    ]
                                  : [
                                      item.text.type == "text"
                                        ? _c("div", {
                                            staticClass: "msg-text",
                                            class: {
                                              disabled:
                                                _vm.level ==
                                                _vm.publishBotMessages.length
                                            },
                                            domProps: {
                                              innerHTML: _vm._s(item.text.info)
                                            }
                                          })
                                        : _vm._e(),
                                      item.text.type == "link"
                                        ? _c("div", { staticClass: "w-full" }, [
                                            item.text.mode == "assistant"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "assistant-mode w-full d-flex align-items-center flex-column justify-content-center"
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        width: "97",
                                                        height: "97",
                                                        src: require("assets/assistant/assistant-avatar.png"),
                                                        alt: ""
                                                      }
                                                    }),
                                                    _c("h2", [
                                                      _vm._v(
                                                        "Tap Call to Enable AI Assistant"
                                                      )
                                                    ]),
                                                    _c("h6", [
                                                      _vm._v(
                                                        "Never miss important calls"
                                                      )
                                                    ]),
                                                    _c("img", {
                                                      staticClass: "arrow",
                                                      attrs: {
                                                        width: "40",
                                                        height: "40",
                                                        src: require("assets/assistant/arrow.svg"),
                                                        alt: ""
                                                      }
                                                    }),
                                                    _vm.show_call_button
                                                      ? _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "assistant-call",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.call()
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Call " +
                                                                _vm._s(
                                                                  _vm.forwarding_active_code
                                                                )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              : _c("div", [
                                                  _c("div", {
                                                    staticClass: "msg-text",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        item.text.info
                                                      )
                                                    }
                                                  }),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex btn-options btn-group"
                                                    },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass: "btn",
                                                          attrs: {
                                                            target: "_blank",
                                                            href: _vm.deeplink
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.updateDeeplinkFrom(
                                                                "CHAT_DEEPLINK_1"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("div", [
                                                            _c(
                                                              "svg",
                                                              {
                                                                attrs: {
                                                                  xmlns:
                                                                    "http://www.w3.org/2000/svg",
                                                                  width: "17",
                                                                  height: "20",
                                                                  viewBox:
                                                                    "0 0 17 20",
                                                                  fill: "none"
                                                                }
                                                              },
                                                              [
                                                                _c("path", {
                                                                  attrs: {
                                                                    d:
                                                                      "M14.2578 10.636C14.2349 8.10926 16.3461 6.88001 16.4427 6.82278C15.247 5.09573 13.3937 4.85975 12.7424 4.84094C11.1858 4.67866 9.67595 5.76366 8.88302 5.76366C8.07427 5.76366 6.85324 4.85662 5.53724 4.88327C3.84377 4.90914 2.25951 5.88047 1.39062 7.3888C-0.402556 10.4643 0.934808 14.9838 2.65281 17.4697C3.5122 18.6872 4.51641 20.0466 5.83083 19.9988C7.11675 19.9462 7.5971 19.1866 9.14891 19.1866C10.6865 19.1866 11.1375 19.9988 12.4781 19.9682C13.8582 19.9462 14.7271 18.7452 15.5564 17.5168C16.5495 16.1213 16.9484 14.747 16.9642 14.6765C16.9317 14.6655 14.2839 13.6644 14.2578 10.636Z",
                                                                    fill:
                                                                      "white"
                                                                  }
                                                                }),
                                                                _c("path", {
                                                                  attrs: {
                                                                    d:
                                                                      "M11.7255 3.2056C12.4171 2.34874 12.8904 1.18299 12.759 0C11.758 0.0439016 10.5061 0.685963 9.78515 1.52401C9.14733 2.2625 8.57757 3.47293 8.72476 4.61124C9.84925 4.69434 11.0038 4.04914 11.7255 3.2056Z",
                                                                    fill:
                                                                      "white"
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          ]),
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm._f("trans")(
                                                                  "st_public.iPhone"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass: "btn",
                                                          attrs: {
                                                            target: "_blank",
                                                            href: _vm.deeplink
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.updateDeeplinkFrom(
                                                                "CHAT_DEEPLINK_2"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("div", [
                                                            _c(
                                                              "svg",
                                                              {
                                                                attrs: {
                                                                  xmlns:
                                                                    "http://www.w3.org/2000/svg",
                                                                  width: "18",
                                                                  height: "20",
                                                                  viewBox:
                                                                    "0 0 18 20",
                                                                  fill: "none"
                                                                }
                                                              },
                                                              [
                                                                _c("path", {
                                                                  attrs: {
                                                                    d:
                                                                      "M1.52693 6.47852C1.18233 6.47852 0.889951 6.59869 0.64961 6.83903C0.409269 7.07937 0.289062 7.36777 0.289062 7.70438V12.8726C0.289062 13.2176 0.409233 13.5098 0.64961 13.7501C0.889951 13.9905 1.18233 14.1107 1.52693 14.1107C1.87128 14.1107 2.16188 13.9905 2.3985 13.7501C2.63465 13.5098 2.75304 13.2176 2.75304 12.8726V7.70438C2.75304 7.36773 2.63287 7.07937 2.3925 6.83903C2.15212 6.59869 1.86354 6.47852 1.52693 6.47852Z",
                                                                    fill:
                                                                      "white"
                                                                  }
                                                                }),
                                                                _c("path", {
                                                                  attrs: {
                                                                    d:
                                                                      "M11.4805 1.83878L12.3339 0.264526C12.3899 0.160304 12.37 0.0803828 12.2739 0.0241852C12.1696 -0.0242736 12.0895 0.000281275 12.0336 0.0961138L11.1683 1.68296C10.4068 1.34631 9.60152 1.17768 8.7523 1.17768C7.9029 1.17768 7.0975 1.34635 6.33638 1.68296L5.47103 0.0961138C5.41479 0.000281275 5.33469 -0.0240566 5.23069 0.0241852C5.13442 0.080636 5.11449 0.160304 5.17073 0.264526L6.02414 1.83878C5.15879 2.28008 4.46959 2.89468 3.9568 3.6839C3.44401 4.47356 3.1875 5.33649 3.1875 6.2742H14.305C14.305 5.33671 14.0485 4.47374 13.5357 3.6839C13.0229 2.89468 12.3377 2.28008 11.4805 1.83878ZM6.54663 4.12857C6.45434 4.22107 6.34412 4.26711 6.21599 4.26711C6.08761 4.26711 5.97963 4.22107 5.89153 4.12857C5.80344 4.0365 5.75939 3.9267 5.75939 3.79814C5.75939 3.67002 5.80344 3.56001 5.89153 3.46772C5.97963 3.37565 6.08786 3.32961 6.21599 3.32961C6.34412 3.32961 6.45434 3.37565 6.54663 3.46772C6.6387 3.56023 6.68495 3.67002 6.68495 3.79814C6.6847 3.92649 6.63848 4.0365 6.54663 4.12857ZM11.6126 4.12857C11.5243 4.22107 11.4161 4.26711 11.2882 4.26711C11.1598 4.26711 11.0496 4.22107 10.9575 4.12857C10.8652 4.0365 10.8192 3.9267 10.8192 3.79814C10.8192 3.67002 10.8652 3.56001 10.9575 3.46772C11.0496 3.37565 11.1598 3.32961 11.2882 3.32961C11.4163 3.32961 11.5243 3.37565 11.6126 3.46772C11.7008 3.56023 11.7447 3.67002 11.7447 3.79814C11.7447 3.92649 11.7007 4.0365 11.6126 4.12857Z",
                                                                    fill:
                                                                      "white"
                                                                  }
                                                                }),
                                                                _c("path", {
                                                                  attrs: {
                                                                    d:
                                                                      "M3.23438 14.7119C3.23438 15.0808 3.3625 15.3931 3.61879 15.6494C3.8753 15.9057 4.1876 16.0339 4.55629 16.0339H5.44576L5.45794 18.7625C5.45794 19.1071 5.57811 19.3997 5.81845 19.64C6.0588 19.8804 6.34741 20.0006 6.6838 20.0006C7.02819 20.0006 7.32075 19.8804 7.56112 19.64C7.8015 19.3997 7.92167 19.1071 7.92167 18.7625V16.0341H9.58026V18.7625C9.58026 19.1071 9.7004 19.3997 9.94077 19.64C10.1811 19.8804 10.4735 20.0006 10.8181 20.0006C11.1625 20.0006 11.455 19.8804 11.6954 19.64C11.9358 19.3997 12.0559 19.1071 12.0559 18.7625V16.0341H12.9574C13.3179 16.0341 13.6262 15.9059 13.883 15.6497C14.1392 15.3934 14.2674 15.0811 14.2674 14.7122V6.70703H3.23438V14.7119Z",
                                                                    fill:
                                                                      "white"
                                                                  }
                                                                }),
                                                                _c("path", {
                                                                  attrs: {
                                                                    d:
                                                                      "M15.9759 6.47852C15.6393 6.47852 15.3509 6.59691 15.1105 6.83306C14.8702 7.06964 14.75 7.36025 14.75 7.70438V12.8726C14.75 13.2176 14.8701 13.5098 15.1105 13.7501C15.3509 13.9905 15.6395 14.1107 15.9759 14.1107C16.3203 14.1107 16.6128 13.9905 16.8532 13.7501C17.0936 13.5098 17.2137 13.2176 17.2137 12.8726V7.70438C17.2137 7.36021 17.0936 7.06964 16.8532 6.83306C16.6128 6.59691 16.3203 6.47852 15.9759 6.47852Z",
                                                                    fill:
                                                                      "white"
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          ]),
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm._f("trans")(
                                                                  "st_public.Android"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ])
                                          ])
                                        : _vm._e(),
                                      item.text.type == "text" &&
                                      item.text.suggestions &&
                                      _vm.messages.length == 1
                                        ? _c("div", [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "msger-suggestion"
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("trans")(
                                                        "st_public.suggested_answer"
                                                      )
                                                    )
                                                  )
                                                ]),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "msger-suggestion-btn"
                                                  },
                                                  _vm._l(
                                                    item.text.suggestions,
                                                    function(option, index) {
                                                      return _c(
                                                        "a",
                                                        {
                                                          key: index,
                                                          staticClass:
                                                            "btn suggestion-btn",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.chooseOption(
                                                                option
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f("trans")(
                                                                "st_public." +
                                                                  option.info
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              ]
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                              ]
                            : [_vm._m(0, true)]
                        ],
                        2
                      )
                    ]
                  ),
                  !item.isLoading
                    ? _c("div", { staticClass: "w-full" }, [
                        item.text.type == "text" && item.text.isDay
                          ? _c("div", { staticClass: "w-full" }, [
                              !item.hide
                                ? _c("div", { staticClass: "msger-days" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("trans")(
                                            "st_public.Select a Day"
                                          )
                                        )
                                      )
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "msger-days-btn" },
                                      _vm._l(
                                        _vm.sortedDays(item.text.options),
                                        function(day, index) {
                                          return _c(
                                            "a",
                                            {
                                              key: index,
                                              staticClass: "btn days-btn",
                                              on: {
                                                click: function($event) {
                                                  return _vm.chooseDay(
                                                    day,
                                                    index,
                                                    item.id
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  index == _vm.currentDayIndex
                                                    ? _vm.$root.trans(
                                                        "st_public.Today"
                                                      )
                                                    : _vm.$root.trans(
                                                        "st_public." + day
                                                      )
                                                )
                                              )
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  ])
                                : _vm._e()
                            ])
                          : _vm._e(),
                        item.text.type == "text" && item.text.isTime
                          ? _c("div", { staticClass: "w-full" }, [
                              !item.hide
                                ? _c("div", { staticClass: "msger-days" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("trans")(
                                            "st_public.Select time"
                                          )
                                        )
                                      )
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "msger-days-btn" },
                                      _vm._l(item.text.options, function(
                                        time,
                                        index
                                      ) {
                                        return _c(
                                          "a",
                                          {
                                            key: index,
                                            staticClass: "btn days-btn",
                                            on: {
                                              click: function($event) {
                                                return _vm.chooseTime(
                                                  time,
                                                  index,
                                                  item.id
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(time))]
                                        )
                                      }),
                                      0
                                    )
                                  ])
                                : _vm._e()
                            ])
                          : _vm._e()
                      ])
                    : _vm._e()
                ]
              )
            }),
            0
          ),
          _c(
            "form",
            {
              staticClass: "msger-inputarea",
              attrs: { id: "msger-inputarea" }
            },
            [
              _c("div", { staticClass: "msger-input-container" }, [
                _c("div", { staticClass: "msger-input-form" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.text,
                        expression: "text"
                      }
                    ],
                    ref: "textarea",
                    staticClass: "form-control msger-input",
                    class: { disabled: _vm.disableSendMessage },
                    attrs: {
                      id: "msger-input",
                      rows: "1",
                      placeholder: this.$root.trans(
                        "st_public.Type your message..."
                      )
                    },
                    domProps: { value: _vm.text },
                    on: {
                      focus: _vm.onTap,
                      blur: _vm.onBlur,
                      keydown: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.onPressEnter($event)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.text = $event.target.value
                      }
                    }
                  }),
                  _c(
                    "button",
                    {
                      ref: "outsideDiv",
                      staticClass: "msger-send-btn",
                      attrs: {
                        disabled: _vm.disableSendMessage,
                        type: "button"
                      },
                      on: {
                        click: function($event) {
                          return _vm.sendMessage()
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          width: "32",
                          height: "32",
                          src: require("assets/assistant-button.svg"),
                          alt: ""
                        }
                      })
                    ]
                  )
                ]),
                _c("div", { staticClass: "msger-input-privacy" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "13",
                        height: "14",
                        viewBox: "0 0 13 14",
                        fill: "none"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d:
                            "M2.70964 5.83268V4.08268C2.70964 3.07707 3.10911 2.11264 3.82019 1.40157C4.53126 0.690494 5.49569 0.291016 6.5013 0.291016C7.50691 0.291016 8.47133 0.690494 9.18242 1.40157C9.8935 2.11264 10.293 3.07707 10.293 4.08268V5.83268H10.5846C11.5512 5.83268 12.3346 6.61616 12.3346 7.58268V11.666C12.3346 12.6325 11.5512 13.416 10.5846 13.416H2.41797C1.45147 13.416 0.667969 12.6325 0.667969 11.666V7.58268C0.667969 6.61616 1.45147 5.83268 2.41797 5.83268H2.70964ZM5.05763 2.63901C5.44051 2.25612 5.95979 2.04102 6.5013 2.04102C7.04281 2.04102 7.56209 2.25612 7.94499 2.63901C8.32789 3.02189 8.54297 3.5412 8.54297 4.08268V5.83268H4.45963V4.08268C4.45963 3.5412 4.67474 3.02189 5.05763 2.63901Z",
                          fill: "white"
                        }
                      })
                    ]
                  ),
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm._f("trans")(
                          "st_public.Message privately,  end-to-end encryption."
                        )
                      ) +
                      "\n        "
                  )
                ])
              ])
            ]
          )
        ]
      ),
      _vm.mode == "chatbot"
        ? _c("div", [
            !_vm.download
              ? _c("section", { staticClass: "assistant-lp" }, [
                  _c(
                    "div",
                    { staticClass: "assistant-lp-info" },
                    [
                      _vm.lang == "en"
                        ? _c("img", {
                            attrs: {
                              height: "300",
                              width: "317",
                              src: require("assets/assistant/info.png"),
                              alt: ""
                            }
                          })
                        : _vm._e(),
                      _vm.lang == "ar"
                        ? _c("img", {
                            attrs: {
                              height: "300",
                              width: "317",
                              src: require("assets/assistant/info-ar.png"),
                              alt: ""
                            }
                          })
                        : _vm._e(),
                      _c("h2", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("trans")(
                                "st_public.Let Your Assistant Answer for you"
                              )
                            )
                        )
                      ]),
                      _c("p", [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("trans")(
                                "st_public.The smartest call screening available"
                              )
                            ) +
                            "\n        "
                        )
                      ]),
                      _c("assistant-store", {
                        attrs: { deeplink: _vm.deeplink },
                        on: { "update-deeplink-from": _vm.updateDeeplinkFrom }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "assistant-lp-benifts" }, [
                    _c("h2", [
                      _vm._v(
                        _vm._s(_vm._f("trans")("st_public.Benefits List:"))
                      )
                    ]),
                    _c("ul", [
                      _c("li", [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "21",
                              height: "24",
                              viewBox: "0 0 21 24",
                              fill: "none"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d:
                                  "M19.5759 17.7995C18.9314 16.9878 17.8848 15.8117 16.9888 15.7003C16.4437 15.6325 15.8172 16.0843 15.1998 16.5105C15.0793 16.5707 14.1487 17.1249 14.0357 17.158C13.4394 17.3282 12.1669 17.3778 11.3974 16.6761C10.6565 15.9984 9.48491 14.744 8.5392 13.595C7.63566 12.4114 6.68845 10.9883 6.20355 10.1149C5.69757 9.20984 6.06199 8.01265 6.37522 7.48559C6.43245 7.39071 7.12516 6.67842 7.28027 6.51277L7.30286 6.53988C7.8766 6.05799 8.47746 5.56857 8.54522 5.0385C8.65666 4.15604 7.75463 2.87151 7.1101 2.05832C6.46557 1.24363 5.46716 -0.18246 4.10733 0.0193309C3.59533 0.0946259 3.1541 0.273828 2.71889 0.531337L2.70685 0.517784C2.69781 0.523808 2.65565 0.556937 2.63456 0.573502C2.62101 0.581032 2.60896 0.58555 2.59692 0.593079L2.60143 0.599103C2.35145 0.791858 1.63766 1.32495 1.55634 1.39723C0.673881 2.1818 -0.654324 4.02954 0.372701 7.35307C1.13469 9.82274 2.75955 12.7231 4.97323 15.6566L4.96118 15.6671C5.06961 15.8087 5.18104 15.9367 5.29398 16.0737C5.3994 16.2138 5.5033 16.3523 5.61173 16.4909L5.62679 16.4803C7.97599 19.3099 10.4396 21.5718 12.688 22.906C15.7148 24.701 17.8667 23.8924 18.8606 23.2494C18.954 23.1876 19.6648 22.6349 19.9057 22.4527L19.9118 22.4588C19.9208 22.4497 19.9268 22.4377 19.9389 22.4286C19.9569 22.4151 19.9961 22.385 20.0036 22.3789L19.9946 22.3669C20.359 22.0145 20.6512 21.638 20.853 21.1637C21.3815 19.9153 20.2205 18.6142 19.5759 17.7995Z",
                                fill: "black"
                              }
                            })
                          ]
                        ),
                        _c("div", { staticClass: "d-flex flex-column" }, [
                          _c("h5", [
                            _vm._v(
                              _vm._s(
                                _vm._f("trans")(
                                  "st_public.Advanced Call Identification"
                                )
                              )
                            )
                          ]),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm._f("trans")(
                                  "st_public.Your Assistant will find out who is calling and the reason for the phone call, using advanced technology."
                                )
                              )
                            )
                          ])
                        ])
                      ]),
                      _c("li", [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "17",
                              height: "26",
                              viewBox: "0 0 17 26",
                              fill: "none"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d:
                                  "M2 2.97647C2 2.43718 2.43718 2 2.97647 2H5V2.26888C5 2.63707 5.44772 2.93555 6 2.93555H10C10.5523 2.93555 11 2.63707 11 2.26888V2H13.1412C13.6805 2 14.1176 2.43718 14.1176 2.97647V22.1765C14.1176 22.7158 13.6805 23.1529 13.1412 23.1529H2.97647C2.43718 23.1529 2 22.7158 2 22.1765V2.97647ZM2.97647 0C1.33261 0 0 1.33261 0 2.97647V22.1765C0 23.8203 1.33261 25.1529 2.97647 25.1529H13.1412C14.785 25.1529 16.1176 23.8203 16.1176 22.1765V2.97647C16.1176 1.33261 14.785 0 13.1412 0H2.97647Z",
                                fill: "black"
                              }
                            }),
                            _c("circle", {
                              attrs: {
                                cx: "8",
                                cy: "8",
                                r: "3",
                                fill: "#D9D9D9"
                              }
                            }),
                            _c("circle", {
                              attrs: {
                                cx: "5",
                                cy: "20",
                                r: "1",
                                fill: "#D9D9D9"
                              }
                            }),
                            _c("circle", {
                              attrs: {
                                cx: "11",
                                cy: "20",
                                r: "1",
                                fill: "#D9D9D9"
                              }
                            })
                          ]
                        ),
                        _c("div", { staticClass: "d-flex flex-column" }, [
                          _c("h5", [
                            _vm._v(
                              _vm._s(
                                _vm._f("trans")("st_public.Know hows calling")
                              )
                            )
                          ]),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm._f("trans")(
                                  "st_public.The Assistant will ask the caller questions to understand why they’re calling, saving you time and hassle."
                                )
                              )
                            )
                          ])
                        ])
                      ]),
                      _c("li", [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "30",
                              height: "31",
                              viewBox: "0 0 30 31",
                              fill: "none"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d:
                                  "M19.92 3.56836L26.875 10.5271V20.3646L19.92 27.3184H10.0825L3.125 20.3634V10.5259L10.0825 3.56836H19.92ZM18.8838 6.06836H11.1175L5.62625 11.5621V19.3284L11.1175 24.8209H18.8838L24.3762 19.3284V11.5609L18.8838 6.06836ZM13.75 19.1934H16.25V21.6934H13.75V19.1934ZM13.75 9.19336H16.25V16.6934H13.75V9.19336Z",
                                fill: "black"
                              }
                            })
                          ]
                        ),
                        _c("div", { staticClass: "d-flex flex-column" }, [
                          _c("h5", [
                            _vm._v(
                              _vm._s(
                                _vm._f("trans")("st_public.Spam Call Detector")
                              )
                            )
                          ]),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm._f("trans")(
                                  "st_public.Our AI filters this data and is able to tell with more than 90% accuracy if the call is spam or not. With all this information, it is easier than ever to decide whether or not to pick up the call, or block!"
                                )
                              )
                            )
                          ])
                        ])
                      ]),
                      _c("li", [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "24",
                              height: "24",
                              viewBox: "0 0 24 24",
                              fill: "none"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d:
                                  "M8.99922 12.75C9.59922 9.6 10.4242 8.775 13.5742 8.175C13.9492 8.1 14.1742 7.8 14.1742 7.425C14.1742 7.05 13.9492 6.75 13.5742 6.675C10.4242 6.075 9.59922 5.25 8.99922 2.1C8.92422 1.725 8.62422 1.5 8.24922 1.5C7.87422 1.5 7.57422 1.725 7.49922 2.1C6.89922 5.25 6.07422 6.075 2.92422 6.675C2.62422 6.75 2.32422 7.05 2.32422 7.425C2.32422 7.8 2.54922 8.1 2.92422 8.175C6.07422 8.775 6.89922 9.6 7.49922 12.75C7.57422 13.125 7.87422 13.35 8.24922 13.35C8.62422 13.35 8.92422 13.05 8.99922 12.75Z",
                                fill: "black"
                              }
                            }),
                            _c("path", {
                              attrs: {
                                d:
                                  "M16.4984 18.0004C14.3984 17.5504 13.9484 17.1004 13.4984 15.0004C13.4234 14.6254 13.1234 14.4004 12.7484 14.4004C12.3734 14.4004 12.0734 14.6254 11.9984 15.0004C11.5484 17.1004 11.0984 17.5504 8.99844 18.0004C8.62344 18.0754 8.39844 18.3754 8.39844 18.7504C8.39844 19.1254 8.62344 19.4254 8.99844 19.5004C11.0984 19.9504 11.5484 20.4004 11.9984 22.5004C12.0734 22.8754 12.3734 23.1004 12.7484 23.1004C13.1234 23.1004 13.4234 22.8754 13.4984 22.5004C13.9484 20.4004 14.3984 19.9504 16.4984 19.5004C16.8734 19.4254 17.0984 19.1254 17.0984 18.7504C17.0984 18.3754 16.7984 18.0754 16.4984 18.0004Z",
                                fill: "black"
                              }
                            }),
                            _c("path", {
                              attrs: {
                                d:
                                  "M21.8984 10.4992C20.2484 10.1992 19.8734 9.82422 19.5734 8.17422C19.4984 7.79922 19.1984 7.57422 18.8234 7.57422C18.4484 7.57422 18.1484 7.79922 18.0734 8.17422C17.7734 9.82422 17.3984 10.1992 15.7484 10.4992C15.3734 10.5742 15.1484 10.8742 15.1484 11.2492C15.1484 11.6242 15.3734 11.9242 15.7484 11.9992C17.3984 12.2992 17.7734 12.6742 18.0734 14.3242C18.1484 14.6992 18.4484 14.9242 18.8234 14.9242C19.1984 14.9242 19.4984 14.6992 19.5734 14.3242C19.8734 12.6742 20.2484 12.2992 21.8984 11.9992C22.2734 11.9242 22.4984 11.6242 22.4984 11.2492C22.4984 10.8742 22.2734 10.5742 21.8984 10.4992Z",
                                fill: "black"
                              }
                            }),
                            _c("path", {
                              attrs: {
                                d:
                                  "M4.275 16.7241C4.05 16.4991 3.75 16.4241 3.45 16.5741C3.375 16.5741 3.3 16.6491 3.225 16.7241C3.15 16.7991 3.075 16.8741 3.075 16.9491C3 17.0241 3 17.1741 3 17.2491C3 17.3241 3 17.4741 3.075 17.5491C3.15 17.6241 3.15 17.6991 3.225 17.7741C3.3 17.8491 3.375 17.9241 3.45 17.9241C3.525 17.9991 3.675 17.9991 3.75 17.9991C3.825 17.9991 3.975 17.9991 4.05 17.9241C4.125 17.8491 4.2 17.8491 4.275 17.7741C4.35 17.6991 4.425 17.6241 4.425 17.5491C4.5 17.4741 4.5 17.3241 4.5 17.2491C4.5 17.1741 4.5 17.0241 4.425 16.9491C4.425 16.8741 4.35 16.7991 4.275 16.7241Z",
                                fill: "black"
                              }
                            }),
                            _c("path", {
                              attrs: {
                                d:
                                  "M21 5.25078C21.225 5.25078 21.375 5.17578 21.525 5.02578C21.675 4.87578 21.75 4.72578 21.75 4.50078C21.75 4.27578 21.675 4.12578 21.525 3.97578C21.45 3.90078 21.375 3.82578 21.3 3.82578C21.15 3.75078 20.925 3.75078 20.7 3.82578C20.625 3.82578 20.55 3.90078 20.475 3.97578C20.325 4.12578 20.25 4.27578 20.25 4.50078C20.25 4.72578 20.325 4.87578 20.475 5.02578C20.625 5.17578 20.775 5.25078 21 5.25078Z",
                                fill: "black"
                              }
                            })
                          ]
                        ),
                        _c("div", { staticClass: "d-flex flex-column" }, [
                          _c("h5", [
                            _vm._v(
                              _vm._s(
                                _vm._f("trans")("st_public.Custom assistants")
                              )
                            )
                          ]),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm._f("trans")(
                                  "st_public.Choose between 7 custom assistants with different voices. Opt for the call assistant whose voice best suits your needs."
                                )
                              )
                            )
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _c(
                    "div",
                    { staticClass: "assistant-lp-steps" },
                    [
                      _c("h2", [
                        _vm._v(_vm._s(_vm._f("trans")("st_public.How it work")))
                      ]),
                      _c("ul", [
                        _c("li", [
                          _c("img", {
                            attrs: {
                              width: "60",
                              height: "62",
                              src: require("assets/assistant/step1.svg"),
                              alt: ""
                            }
                          }),
                          _c("div", { staticClass: "d-flex flex-column" }, [
                            _c("h5", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("trans")("st_public.Download Who App")
                                )
                              )
                            ]),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("trans")(
                                    "st_public.Who Assistant is part of Who App available on iOS and Android"
                                  )
                                ) + "\n              "
                              )
                            ])
                          ])
                        ]),
                        _c("li", [
                          _c("img", {
                            attrs: {
                              width: "60",
                              height: "62",
                              src: require("assets/assistant/step2.svg"),
                              alt: ""
                            }
                          }),
                          _c("div", { staticClass: "d-flex flex-column" }, [
                            _c("h5", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("trans")(
                                    "st_public.Choose your Assistant’s"
                                  )
                                )
                              )
                            ]),
                            _c("p", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm._f("trans")(
                                      "st_public.Select between a range of different type of response."
                                    )
                                  ) +
                                  "\n              "
                              )
                            ])
                          ])
                        ]),
                        _c("li", [
                          _c("img", {
                            attrs: {
                              width: "60",
                              height: "62",
                              src: require("assets/assistant/step3.svg"),
                              alt: ""
                            }
                          }),
                          _c("div", { staticClass: "d-flex flex-column" }, [
                            _c("h5", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("trans")(
                                    "st_public.Enjoy being Spam-Free!"
                                  )
                                )
                              )
                            ]),
                            _c("p", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm._f("trans")(
                                      "st_public.Combined with our famous Caller ID and Spam Blocking, Who won’t let any unwanted calls through."
                                    )
                                  ) +
                                  "\n              "
                              )
                            ])
                          ])
                        ])
                      ]),
                      _c("store", {
                        attrs: { deeplink: _vm.deeplink },
                        on: { "update-deeplink-from": _vm.updateDeeplinkFrom }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm.download
              ? _c("section", { staticClass: "download-assistant" }, [
                  _c("div", { staticClass: "download-header" }, [
                    _c("div", { staticClass: "download-logo" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "88",
                            height: "24",
                            viewBox: "0 0 88 24",
                            fill: "none"
                          }
                        },
                        [
                          _c("rect", {
                            attrs: {
                              y: "0.742188",
                              width: "22.5185",
                              height: "22.5185",
                              rx: "4",
                              fill: "url(#paint0_linear_13169_9043)"
                            }
                          }),
                          _c(
                            "g",
                            {
                              attrs: { "clip-path": "url(#clip0_13169_9043)" }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  "fill-rule": "evenodd",
                                  "clip-rule": "evenodd",
                                  d:
                                    "M12.6619 20.7314C13.4704 20.3014 14.2355 19.8168 14.95 19.2822C15.2783 19.0366 15.596 18.7804 15.9023 18.5141C15.929 18.4908 15.9557 18.4675 15.9823 18.444C15.9826 18.4438 15.9828 18.4435 15.9831 18.4433L15.9758 18.4364C15.976 18.4362 15.9763 18.436 15.9765 18.4358C16.0005 18.4154 16.0268 18.3926 16.0551 18.3673C16.2547 18.1888 16.556 17.8889 16.9028 17.4971C17.5303 16.7882 18.3067 15.7783 18.8997 14.6413C19.0451 14.3621 19.1225 14.0502 19.1225 13.7384V6.3275C19.1225 5.50473 18.5639 4.79087 17.7333 4.55027L11.8509 2.84731C11.4754 2.7384 11.0779 2.7384 10.7023 2.84731L4.81893 4.55027C3.98832 4.79087 3.42969 5.50473 3.42969 6.3275V13.7384C3.42969 14.0502 3.5071 14.3621 3.65251 14.6413C4.79801 16.8403 6.49168 18.375 6.56909 18.4443C7.17405 18.9763 7.82368 19.4687 8.51277 19.9179C9.17018 20.3465 9.86352 20.7358 10.5883 21.0829C10.8042 21.1866 11.0399 21.2381 11.2767 21.2383C11.2771 21.2383 11.2774 21.2383 11.2777 21.2383C11.278 21.2383 11.2784 21.2383 11.2787 21.2383L11.2777 21.2374C11.278 21.2374 11.2784 21.2374 11.2787 21.2374C11.279 21.2374 11.2793 21.2374 11.2797 21.2374C11.5165 21.2371 11.7522 21.1856 11.9681 21.0819C12.2027 20.9695 12.434 20.8526 12.6619 20.7314ZM11.2536 19.9179H11.2777C11.325 19.9179 11.3654 19.9076 11.3971 19.8924L11.3975 19.8922L11.3979 19.892C12.4772 19.3748 13.4768 18.7589 14.3804 18.0574L15.1239 17.4288C15.514 17.0989 16.8529 15.7124 17.7296 14.0316C17.7788 13.9371 17.8031 13.834 17.8031 13.7384V6.3275C17.8031 6.1338 17.6738 5.9068 17.3664 5.81767C17.3663 5.81766 17.3662 5.81764 17.3662 5.81762L11.4835 4.11454C11.3479 4.07525 11.2053 4.07525 11.0698 4.11454L5.18603 5.81762C5.18595 5.81765 5.18587 5.81767 5.18579 5.81769C4.87838 5.90683 4.74913 6.13382 4.74913 6.3275V13.7384C4.74913 13.8341 4.77351 13.9373 4.82276 14.0319C5.33398 15.0132 5.97661 15.8616 6.50987 16.479C6.77452 16.7854 7.00731 17.0292 7.17582 17.1981C7.25995 17.2824 7.32767 17.3477 7.37487 17.3923C7.39846 17.4146 7.41687 17.4317 7.42957 17.4434C7.43592 17.4492 7.44081 17.4537 7.44418 17.4567C7.44489 17.4574 7.44552 17.4579 7.44608 17.4585C8.53201 18.4125 9.78035 19.233 11.1582 19.8929L11.1593 19.8934C11.1852 19.9059 11.217 19.915 11.2536 19.9179Z",
                                  fill: "white"
                                }
                              }),
                              _c("path", {
                                attrs: {
                                  d:
                                    "M15.8022 15.163L15.5449 15.4066C14.7499 16.1591 11.8103 16.4165 8.87485 13.6393C5.94048 10.862 6.20724 8.08383 7.00752 7.32641L7.26905 7.07888C7.68541 6.68482 8.37899 6.75017 8.70642 7.21353L9.78392 8.74422C10.0308 9.09472 9.98164 9.56105 9.66676 9.85907L9.10708 10.3888C8.96377 10.5244 8.91669 10.7234 9.0098 10.8937C9.18031 11.2026 9.53495 11.7403 10.2076 12.3779C10.8813 13.0155 11.4483 13.3511 11.7747 13.5115C11.9536 13.5997 12.1649 13.5541 12.3082 13.4195L12.8679 12.8898C13.1828 12.5917 13.6755 12.5452 14.0458 12.7789L15.6568 13.7957C16.1496 14.1066 16.2197 14.767 15.8002 15.163H15.8022Z",
                                  fill: "white"
                                }
                              })
                            ]
                          ),
                          _c("rect", {
                            attrs: {
                              y: "0.742188",
                              width: "22.5185",
                              height: "22.5185",
                              rx: "4",
                              stroke: "white"
                            }
                          }),
                          _c("path", {
                            attrs: {
                              d:
                                "M30.1122 18L27.2884 7.81818H28.9041L30.8878 15.7031H30.9822L33.0455 7.81818H34.6463L36.7095 15.7081H36.804L38.7827 7.81818H40.4034L37.5746 18H36.0284L33.8857 10.3736H33.8061L31.6634 18H30.1122ZM43.0453 13.4659V18H41.5588V7.81818H43.0255V11.6065H43.1199C43.2989 11.1955 43.5723 10.8691 43.9402 10.6271C44.3081 10.3852 44.7887 10.2642 45.382 10.2642C45.9057 10.2642 46.3631 10.3719 46.7541 10.5874C47.1486 10.8028 47.4535 11.1243 47.6689 11.5518C47.8877 11.9761 47.997 12.5064 47.997 13.1428V18H46.5105V13.3217C46.5105 12.7616 46.3664 12.3274 46.078 12.0192C45.7897 11.7076 45.3886 11.5518 44.8749 11.5518C44.5236 11.5518 44.2087 11.6264 43.9303 11.7756C43.6552 11.9247 43.4381 12.1435 43.279 12.4318C43.1232 12.7169 43.0453 13.0616 43.0453 13.4659ZM53.0713 18.1541C52.3554 18.1541 51.7307 17.9901 51.197 17.6619C50.6634 17.3338 50.2491 16.8748 49.9541 16.2848C49.6592 15.6948 49.5117 15.0054 49.5117 14.2166C49.5117 13.4245 49.6592 12.7318 49.9541 12.1385C50.2491 11.5452 50.6634 11.0845 51.197 10.7564C51.7307 10.4283 52.3554 10.2642 53.0713 10.2642C53.7872 10.2642 54.412 10.4283 54.9456 10.7564C55.4792 11.0845 55.8935 11.5452 56.1885 12.1385C56.4835 12.7318 56.631 13.4245 56.631 14.2166C56.631 15.0054 56.4835 15.6948 56.1885 16.2848C55.8935 16.8748 55.4792 17.3338 54.9456 17.6619C54.412 17.9901 53.7872 18.1541 53.0713 18.1541ZM53.0763 16.9062C53.5403 16.9062 53.9248 16.7836 54.2297 16.5384C54.5346 16.2931 54.76 15.9666 54.9058 15.5589C55.055 15.1513 55.1296 14.7022 55.1296 14.2116C55.1296 13.7244 55.055 13.277 54.9058 12.8693C54.76 12.4583 54.5346 12.1286 54.2297 11.88C53.9248 11.6314 53.5403 11.5071 53.0763 11.5071C52.609 11.5071 52.2212 11.6314 51.9129 11.88C51.608 12.1286 51.381 12.4583 51.2318 12.8693C51.086 13.277 51.0131 13.7244 51.0131 14.2116C51.0131 14.7022 51.086 15.1513 51.2318 15.5589C51.381 15.9666 51.608 16.2931 51.9129 16.5384C52.2212 16.7836 52.609 16.9062 53.0763 16.9062ZM62.7227 18H61.0921L64.7561 7.81818H66.531L70.195 18H68.5644L65.6858 9.66761H65.6063L62.7227 18ZM62.9962 14.0128H68.2859V15.3054H62.9962V14.0128ZM71.4201 20.8636V10.3636H72.8718V11.6016H72.9961C73.0822 11.4425 73.2065 11.2585 73.3689 11.0497C73.5313 10.8409 73.7567 10.6586 74.0451 10.5028C74.3334 10.3438 74.7146 10.2642 75.1885 10.2642C75.805 10.2642 76.3552 10.42 76.8391 10.7315C77.323 11.0431 77.7025 11.4922 77.9776 12.0788C78.256 12.6655 78.3952 13.3714 78.3952 14.1967C78.3952 15.022 78.2577 15.7296 77.9826 16.3196C77.7075 16.9062 77.3296 17.3587 76.849 17.6768C76.3685 17.9917 75.8199 18.1491 75.2035 18.1491C74.7394 18.1491 74.3599 18.0713 74.065 17.9155C73.7733 17.7597 73.5446 17.5774 73.3789 17.3686C73.2132 17.1598 73.0856 16.9742 72.9961 16.8118H72.9066V20.8636H71.4201ZM72.8767 14.1818C72.8767 14.7187 72.9546 15.1894 73.1104 15.5938C73.2662 15.9981 73.4916 16.3146 73.7865 16.5433C74.0815 16.7687 74.4428 16.8814 74.8704 16.8814C75.3145 16.8814 75.6857 16.7637 75.984 16.5284C76.2823 16.2898 76.5077 15.9666 76.6601 15.5589C76.8159 15.1513 76.8938 14.6922 76.8938 14.1818C76.8938 13.678 76.8176 13.2256 76.6651 12.8246C76.516 12.4235 76.2906 12.107 75.989 11.875C75.6907 11.643 75.3178 11.527 74.8704 11.527C74.4395 11.527 74.0749 11.638 73.7766 11.8601C73.4816 12.0821 73.2579 12.392 73.1054 12.7898C72.953 13.1875 72.8767 13.6515 72.8767 14.1818ZM79.9347 20.8636V10.3636H81.3864V11.6016H81.5107C81.5969 11.4425 81.7212 11.2585 81.8836 11.0497C82.046 10.8409 82.2713 10.6586 82.5597 10.5028C82.848 10.3438 83.2292 10.2642 83.7032 10.2642C84.3196 10.2642 84.8698 10.42 85.3537 10.7315C85.8376 11.0431 86.2171 11.4922 86.4922 12.0788C86.7706 12.6655 86.9098 13.3714 86.9098 14.1967C86.9098 15.022 86.7723 15.7296 86.4972 16.3196C86.2221 16.9062 85.8443 17.3587 85.3637 17.6768C84.8831 17.9917 84.3346 18.1491 83.7181 18.1491C83.2541 18.1491 82.8746 18.0713 82.5796 17.9155C82.2879 17.7597 82.0592 17.5774 81.8935 17.3686C81.7278 17.1598 81.6002 16.9742 81.5107 16.8118H81.4212V20.8636H79.9347ZM81.3914 14.1818C81.3914 14.7187 81.4693 15.1894 81.625 15.5938C81.7808 15.9981 82.0062 16.3146 82.3012 16.5433C82.5962 16.7687 82.9574 16.8814 83.385 16.8814C83.8291 16.8814 84.2003 16.7637 84.4986 16.5284C84.7969 16.2898 85.0223 15.9666 85.1748 15.5589C85.3305 15.1513 85.4084 14.6922 85.4084 14.1818C85.4084 13.678 85.3322 13.2256 85.1797 12.8246C85.0306 12.4235 84.8052 12.107 84.5036 11.875C84.2053 11.643 83.8324 11.527 83.385 11.527C82.9541 11.527 82.5895 11.638 82.2912 11.8601C81.9962 12.0821 81.7725 12.392 81.6201 12.7898C81.4676 13.1875 81.3914 13.6515 81.3914 14.1818Z",
                              fill: "black",
                              "fill-opacity": "0.9"
                            }
                          }),
                          _c(
                            "defs",
                            [
                              _c(
                                "linearGradient",
                                {
                                  attrs: {
                                    id: "paint0_linear_13169_9043",
                                    x1: "11.2593",
                                    y1: "0.742187",
                                    x2: "11.2593",
                                    y2: "23.2607",
                                    gradientUnits: "userSpaceOnUse"
                                  }
                                },
                                [
                                  _c("stop", {
                                    attrs: { "stop-color": "#19CC9A" }
                                  }),
                                  _c("stop", {
                                    attrs: {
                                      offset: "1",
                                      "stop-color": "#14A37B"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "clipPath",
                                { attrs: { id: "clip0_13169_9043" } },
                                [
                                  _c("rect", {
                                    attrs: {
                                      width: "15.6928",
                                      height: "18.4722",
                                      fill: "white",
                                      transform: "translate(3.42969 2.76562)"
                                    }
                                  })
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ]),
                    _c("div", { staticClass: "download-info" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("trans")("st_public.Download AI Assistant")
                        )
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "download-avatar" }, [
                    _c("div", { staticClass: "download-missed" }, [
                      _vm._v(_vm._s(_vm._f("trans")("st_public.Chat Expired")))
                    ]),
                    _c("img", {
                      attrs: {
                        width: "116",
                        height: "116",
                        src: require("assets/assistant/avatar.png"),
                        alt: ""
                      }
                    }),
                    _c(
                      "span",
                      { staticClass: "download-avatar-latest-online" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("trans")(
                              "st_public.2 minutes recently active"
                            )
                          )
                        )
                      ]
                    ),
                    _c("span", { staticClass: "download-avatar-masked" }, [
                      _vm._v(
                        _vm._s(
                          _vm.displayFirstWordAndFirstCharOfSecondWord(
                            _vm.botName
                          )
                        )
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "download-footer" }, [
                    _c("span", { staticClass: "download-avatar-install" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("trans")(
                            "st_public.Install Who App to see conversation"
                          )
                        )
                      )
                    ]),
                    _c(
                      "a",
                      {
                        staticClass: "assistant-lp-btn",
                        attrs: { target: "_blank", href: _vm.deeplink },
                        on: {
                          click: function($event) {
                            return _vm.updateDeeplinkFrom("DOWNLOAD_DEEPLINK_1")
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("trans")("st_public.Get your FREE Assistant")
                          )
                        )
                      ]
                    ),
                    _c("span", { staticClass: "download-avatar-notes" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm._f("trans")("st_public.Expires in 1 hour")
                          ) +
                          "\n        "
                      )
                    ])
                  ])
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm.mounted ? _c("section", { staticClass: "loading-page" }) : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "msg-loading" }, [
      _c("span", { staticClass: "dot" }),
      _c("span", { staticClass: "dot" }),
      _c("span", { staticClass: "dot" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3940aefb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3940aefb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/_lang/assistant/_id/_token.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3940aefb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/_lang/assistant/_id/_token.vue
// module chunks = 10